export const SHIPMENT_STAGES = {
  LEAD: 'lead',
  QUOTE: 'quote',
  ORDER: 'order',
} as const

export type ShipmentStage =
  (typeof SHIPMENT_STAGES)[keyof typeof SHIPMENT_STAGES]
